import React, { ChangeEvent } from "react";
import InputMask from "react-input-mask";

interface InputCepProps {
  id: string;
  label: string;
  value: string;
  mask: string;
  placeholder: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  readOnly?: boolean;
  maskChar?: string;
}

export const InputCep = ({
  id,
  label,
  value,
  mask,
  placeholder,
  onChange,
  error,
  readOnly,
  maskChar,
}: InputCepProps) => {
  return (
    <div
      className={`
          field-holder 
          ${error ? "field-holder-invalid" : ""}
      `}
    >
      {label && (
        <label htmlFor={id} className="text-gray text-semibold">
          {label}
        </label>
      )}

      {mask ? (
        <InputMask
          maskChar={maskChar || null}
          mask={mask}
          type="string"
          name={id}
          id={id}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          className="input _opacity-gray"
        />
      ) : (
        <input
          id={id}
          name={id}
          type="text"
          className="input _opacity-gray"
          onChange={(e) => onChange(e)}
          value={value}
          placeholder={placeholder}
          maxLength={9}
          readOnly={readOnly}
        />
      )}
    </div>
  );
};
